import { clientEnv } from '@pricedrop/config/client';
import * as Sentry from '@sentry/tanstackstart-react';

let initialized = false;

export function initSentry(
  router: Parameters<typeof Sentry.tanstackRouterBrowserTracingIntegration>[0],
): void {
  if (initialized) return;
  if (!clientEnv.SENTRY_DSN) return;
  if (typeof window === 'undefined') return;

  Sentry.init({
    dsn: clientEnv.SENTRY_DSN,
    tunnel: '/tunnel',
    environment: import.meta.env.MODE,
    integrations: [Sentry.tanstackRouterBrowserTracingIntegration(router)],
    tracesSampleRate: 0,
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 0,
    beforeSend(event) {
      const message = event.exception?.values?.[0]?.value ?? '';
      if (message.includes('ResizeObserver loop')) {
        return null;
      }
      return event;
    },
    initialScope: {
      tags: { service: 'client' },
    },
  });

  initialized = true;
}

export function setSentryUser(user: { id: string } | null): void {
  if (!clientEnv.SENTRY_DSN) return;
  Sentry.setUser(user ? { id: user.id } : null);
}

export { Sentry };
